import { Layout } from '../../enums';
import { Sizes } from './BarChart.types';
import { DESKTOP_MOCKUP_WIDTH, MOBILE_MOCKUP_WIDTH } from '../../constants';

export const SIZES: Record<Layout, Sizes> = {
  mobile: {
    entryWidth: 350,
    barWidth: 30,
    maxBarHeight: 655,
    height: 989,
    topPadding: 26,
    width: MOBILE_MOCKUP_WIDTH,
    yScaleTextOffset: 112,
    yScaleLinesOffset: 219,
    barOffsetLeft: 305,
    activeValueY: 106,
    inactiveValueY: 179,
  },
  desktop: {
    entryWidth: 198.5,
    barWidth: 16,
    maxBarHeight: 380,
    height: 514,
    topPadding: 16,
    width: DESKTOP_MOCKUP_WIDTH,
    yScaleTextOffset: 70,
    yScaleLinesOffset: 116,
    barOffsetLeft: 184,
    activeValueY: 59,
    inactiveValueY: 104,
  },
};
